import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { OpenAPI } from "@/client";
import { OpenAPI as OpenAPIAdmin } from "@/client-admin";
import { isTokenExpired } from "@/lib/utils";

export function useTokenExpirationCheck() {
  const navigate = useNavigate();

  useEffect(() => {
    if (isTokenExpired()) {
      localStorage.removeItem("access_token");
      OpenAPI.TOKEN = undefined;
      OpenAPIAdmin.TOKEN = undefined;
      navigate({ to: "/login" });
    }
  });
}
